module.exports = __webpack_public_path__ + "img/kplc-postpaid.af9210c5.png";